<template>
  <Modal
    :class="{ 'dea-modal--email-delete': deleteMode, 'dea-modal--email': !isMiurEmail }"
    extra-class="dea-modal--no-footer"
    :visible="visible"
    @modal-close="$emit('modal-close')"
  >
    <template #title>
      {{ modalTitle }}
    </template>
    <template #content>
      <InputText v-if="!deleteMode" v-model="newEmail" label="EMAIL"></InputText>
      <Tooltip
        v-if="!isMiurEmail && showTooltip"
        class="dea-tooltip__email-info"
        :negative="true"
        position="left"
        side="top"
      >
        <p>
          Assicurati di poter ricevere le comunicazioni all'indirizzo inserito: ti manderemo una mail per confermare la
          tua registrazione. In caso sia un indirizzo scolastico, chiedi alla tua segreteria di permettere la ricezione
          di email provenienti da @deascuola.it
        </p>
      </Tooltip>
      <Buttons
        v-if="!deleteMode"
        class="dea-button--large"
        :disabled="!newEmail"
        @click="$emit('email-update', newEmail, isMiurEmail)"
        >{{ buttonText }}</Buttons
      >
      <Buttons v-else class="dea-button--large" @click="$emit('email-delete')">Si, rimuovi</Buttons>
      <Buttons v-if="deleteMode" class="dea-button--large dea-button--outline" @click="$emit('modal-close')"
        >Annulla</Buttons
      >
    </template>
  </Modal>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import InputText from "@/components/elements/InputText";
import Tooltip from "@/components/elements/Tooltip";
import Modal from "@/components/patterns/Modal";

export default {
  name: "EmailModal",
  components: { Buttons, InputText, Modal, Tooltip },
  props: {
    emailMode: {
      type: String,
      default: "",
      validator: value => {
        return ["save", "modify", "delete"].indexOf(value) !== -1;
      },
    },
    emailTarget: {
      type: String,
      default: "",
    },
    isMiurEmail: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newEmail: "",
    };
  },
  computed: {
    buttonText() {
      let text;
      if (this.emailMode === "save") {
        text = "Salva e aggiungi";
      } else if (this.emailMode === "modify") {
        text = "Salva modifiche";
      }
      return text;
    },
    deleteMode() {
      return this.emailMode === "delete";
    },
    modalTitle() {
      let text;
      if (this.emailMode === "save") {
        text = "Aggiungi un altro indirizzo email";
      } else if (this.emailMode === "modify") {
        text = this.user.parent_id
          ? `Modifica la mail di ${this.user.firstname} ${this.user.lastname}`
          : "Modifica la tua email";
      } else {
        text = this.user.parent_id
          ? `Vuoi eliminare l'indirizzo: ${this.emailTarget} dal profilo Deascuola di ${this.user.firstname} ${this.user.lastname}`
          : `Vuoi eliminare l'indirizzo: ${this.emailTarget} dal tuo profilo Deascuola?`;
      }
      return text;
    },
    showTooltip() {
      // FIXME: Maybe is better to use a regex and wait for Nicola domains list https://projects.invisionapp.com/d/main#/console/18047421/440394949/comments/139049922
      return this.newEmail.indexOf("@") > -1 && this.newEmail.indexOf("@gmail.com") === -1;
    },
  },
  mounted() {
    if (this.emailTarget && this.emailMode === "modify") this.newEmail = this.emailTarget;
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$mail-input-width: 330px;

.dea-modal--email {
  .dea-button {
    margin-right: $space-base;
    margin-top: $space-small !important; //sass-lint:disable-line no-important
  }
}

.dea-modal--email-delete {
  .dea-modal__content {
    display: flex;

    .dea-button {
      margin-right: $space-base;
    }
  }
}

.dea-modal--email-miur {
  .dea-button {
    margin-top: $space-base !important; //sass-lint:disable-line no-important
  }
}

.dea-tooltip__email-info {
  margin-bottom: $space-small;

  .dea-tooltip__inner {
    width: $mail-input-width;
  }
}
</style>
